import React from "react";
import { WhmButton } from "@securitize/reactjs-whm";
import { translationKeys } from "../../../hooks/useTranslation";
import { Translate } from "../../shared/translation";
import { PortfolioStatementModal } from "./PortfolioStatementModal";

export const PortfolioStatementButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <>
      <WhmButton
        variant="contained"
        color="primary"
        startIcon={<i className="wh-icon-download" />}
        // startIcon={<span class="material-icons-outlined">vertical_align_bottom</span>}
        onClick={() => setIsModalOpen(true)}
      >
        <Translate
          translationKey={translationKeys.PORTFOLIO_STATEMENT_BUTTON_LABEL}
        />
      </WhmButton>

      <PortfolioStatementModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
